// Country Names & codes for the flags
const countryCodes = [
    { id: 1, name: "Afghanistan", code: "AF" },
    { id: 2, name: "Åland Islands", code: "AX" },
    { id: 3, name: "Albania", code: "AL" },
    { id: 4, name: "Algeria", code: "DZ" },
    { id: 5, name: "American Samoa", code: "AS" },
    { id: 6, name: "AndorrA", code: "AD" },
    { id: 7, name: "Angola", code: "AO" },
    { id: 8, name: "Anguilla", code: "AI" },
    { id: 9, name: "Antarctica", code: "AQ" },
    { id: 10, name: "Antigua and Barbuda", code: "AG" },
    { id: 11, name: "Argentina", code: "AR" },
    { id: 12, name: "Armenia", code: "AM" },
    { id: 13, name: "Aruba", code: "AW" },
    { id: 14, name: "Australia", code: "AU" },
    { id: 15, name: "Austria", code: "AT" },
    { id: 16, name: "Azerbaijan", code: "AZ" },
    { id: 17, name: "Bahamas", code: "BS" },
    { id: 18, name: "Bahrain", code: "BH" },
    { id: 19, name: "Bangladesh", code: "BD" },
    { id: 20, name: "Barbados", code: "BB" },
    { id: 21, name: "Belarus", code: "BY" },
    { id: 22, name: "Belgium", code: "BE" },
    { id: 23, name: "Belize", code: "BZ" },
    { id: 24, name: "Benin", code: "BJ" },
    { id: 25, name: "Bermuda", code: "BM" },
    { id: 26, name: "Bhutan", code: "BT" },
    { id: 27, name: "Bolivia", code: "BO" },
    { id: 28, name: "Bosnia and Herzegovina", code: "BA" },
    { id: 29, name: "Botswana", code: "BW" },
    { id: 30, name: "Bouvet Island", code: "BV" },
    { id: 31, name: "Brazil", code: "BR" },
    { id: 32, name: "British Indian Ocean Territory", code: "IO" },
    { id: 33, name: "Brunei Darussalam", code: "BN" },
    { id: 34, name: "Bulgaria", code: "BG" },
    { id: 35, name: "Burkina Faso", code: "BF" },
    { id: 36, name: "Burundi", code: "BI" },
    { id: 37, name: "Cambodia", code: "KH" },
    { id: 39, name: "Cameroon", code: "CM" },
    { id: 40, name: "Canada", code: "CA" },
    { id: 41, name: "Cape Verde", code: "CV" },
    { id: 42, name: "Cayman Islands", code: "KY" },
    { id: 43, name: "Central African Republic", code: "CF" },
    { id: 44, name: "Chad", code: "TD" },
    { id: 45, name: "Chile", code: "CL" },
    { id: 46, name: "China", code: "CN" },
    { id: 47, name: "Christmas Island", code: "CX" },
    { id: 48, name: "Cocos (Keeling) Islands", code: "CC" },
    { id: 49, name: "Colombia", code: "CO" },
    { id: 50, name: "Comoros", code: "KM" },
    { id: 51, name: "Congo", code: "CG" },
    { id: 52, name: "Congo, The Democratic Republic of the", code: "CD" },
    { id: 53, name: "Cook Islands", code: "CK" },
    { id: 54, name: "Costa Rica", code: "CR" },
    { id: 55, name: "Cote D'Ivoire", code: "CI" },
    { id: 56, name: "Croatia", code: "HR" },
    { id: 57, name: "Cuba", code: "CU" },
    { id: 58, name: "Cyprus", code: "CY" },
    { id: 59, name: "Czech Republic", code: "CZ" },
    { id: 60, name: "Denmark", code: "DK" },
    { id: 61, name: "Djibouti", code: "DJ" },
    { id: 62, name: "Dominica", code: "DM" },
    { id: 63, name: "Dominican Republic", code: "DO" },
    { id: 64, name: "Ecuador", code: "EC" },
    { id: 65, name: "Egypt", code: "EG" },
    { id: 66, name: "El Salvador", code: "SV" },
    { id: 67, name: "Equatorial Guinea", code: "GQ" },
    { id: 68, name: "Eritrea", code: "ER" },
    { id: 69, name: "Estonia", code: "EE" },
    { id: 70, name: "Ethiopia", code: "ET" },
    { id: 71, name: "Falkland Islands (Malvinas)", code: "FK" },
    { id: 72, name: "Faroe Islands", code: "FO" },
    { id: 73, name: "Fiji", code: "FJ" },
    { id: 74, name: "Finland", code: "FI" },
    { id: 75, name: "France", code: "FR" },
    { id: 76, name: "French Guiana", code: "GF" },
    { id: 77, name: "French Polynesia", code: "PF" },
    { id: 78, name: "French Southern Territories", code: "TF" },
    { id: 79, name: "Gabon", code: "GA" },
    { id: 80, name: "Gambia", code: "GM" },
    { id: 81, name: "Georgia", code: "GE" },
    { id: 82, name: "Germany", code: "DE" },
    { id: 83, name: "Ghana", code: "GH" },
    { id: 84, name: "Gibraltar", code: "GI" },
    { id: 85, name: "Greece", code: "GR" },
    { id: 86, name: "Greenland", code: "GL" },
    { id: 87, name: "Grenada", code: "GD" },
    { id: 88, name: "Guadeloupe", code: "GP" },
    { id: 89, name: "Guam", code: "GU" },
    { id: 90, name: "Guatemala", code: "GT" },
    { id: 100, name: "Guernsey", code: "GG" },
    { id: 101, name: "Guinea", code: "GN" },
    { id: 102, name: "Guinea-Bissau", code: "GW" },
    { id: 103, name: "Guyana", code: "GY" },
    { id: 104, name: "Haiti", code: "HT" },
    { id: 105, name: "Heard Island and Mcdonald Islands", code: "HM" },
    { id: 106, name: "Holy See (Vatican City State)", code: "VA" },
    { id: 107, name: "Honduras", code: "HN" },
    { id: 108, name: "Hong Kong", code: "HK" },
    { id: 109, name: "Hungary", code: "HU" },
    { id: 110, name: "Iceland", code: "IS" },
    { id: 110, name: "India", code: "IN" },
    { id: 112, name: "Indonesia", code: "ID" },
    { id: 113, name: "Iran, Islamic Republic Of", code: "IR" },
    { id: 114, name: "Iraq", code: "IQ" },
    { id: 115, name: "Ireland", code: "IE" },
    { id: 116, name: "Isle of Man", code: "IM" },
    { id: 117, name: "Israel", code: "IL" },
    { id: 118, name: "Italy", code: "IT" },
    { id: 119, name: "Jamaica", code: "JM" },
    { id: 120, name: "Japan", code: "JP" },
    { id: 121, name: "Jersey", code: "JE" },
    { id: 122, name: "Jordan", code: "JO" },
    { id: 123, name: "Kazakhstan", code: "KZ" },
    { id: 124, name: "Kenya", code: "KE" },
    { id: 125, name: "Kiribati", code: "KI" },
    { id: 126, name: "Korea, Democratic People'S Republic of", code: "KP" },
    { id: 127, name: "Korea, Republic of", code: "KR" },
    { id: 128, name: "Kuwait", code: "KW" },
    { id: 129, name: "Kyrgyzstan", code: "KG" },
    { id: 130, name: "Lao People'S Democratic Republic", code: "LA" },
    { id: 131, name: "Latvia", code: "LV" },
    { id: 132, name: "Lebanon", code: "LB" },
    { id: 133, name: "Lesotho", code: "LS" },
    { id: 134, name: "Liberia", code: "LR" },
    { id: 135, name: "Libyan Arab Jamahiriya", code: "LY" },
    { id: 136, name: "Liechtenstein", code: "LI" },
    { id: 137, name: "Lithuania", code: "LT" },
    { id: 138, name: "Luxembourg", code: "LU" },
    { id: 139, name: "Macao", code: "MO" },
    { id: 140, name: "Macedonia, The Former Yugoslav Republic of", code: "MK" },
    { id: 141, name: "Madagascar", code: "MG" },
    { id: 142, name: "Malawi", code: "MW" },
    { id: 143, name: "Malaysia", code: "MY" },
    { id: 144, name: "Maldives", code: "MV" },
    { id: 145, name: "Mali", code: "ML" },
    { id: 146, name: "Malta", code: "MT" },
    { id: 147, name: "Marshall Islands", code: "MH" },
    { id: 148, name: "Martinique", code: "MQ" },
    { id: 149, name: "Mauritania", code: "MR" },
    { id: 150, name: "Mauritius", code: "MU" },
    { id: 156, name: "Mayotte", code: "YT" },
    { id: 157, name: "Mexico", code: "MX" },
    { id: 158, name: "Micronesia, Federated States of", code: "FM" },
    { id: 159, name: "Moldova, Republic of", code: "MD" },
    { id: 160, name: "Monaco", code: "MC" },
    { id: 161, name: "Mongolia", code: "MN" },
    { id: 162, name: "Montserrat", code: "MS" },
    { id: 163, name: "Morocco", code: "MA" },
    { id: 164, name: "Mozambique", code: "MZ" },
    { id: 165, name: "Myanmar", code: "MM" },
    { id: 166, name: "Namibia", code: "NA" },
    { id: 167, name: "Nauru", code: "NR" },
    { id: 168, name: "Nepal", code: "NP" },
    { id: 169, name: "Netherlands", code: "NL" },
    { id: 170, name: "Netherlands Antilles", code: "AN" },
    { id: 171, name: "New Caledonia", code: "NC" },
    { id: 172, name: "New Zealand", code: "NZ" },
    { id: 173, name: "Nicaragua", code: "NI" },
    { id: 174, name: "Niger", code: "NE" },
    { id: 175, name: "Nigeria", code: "NG" },
    { id: 176, name: "Niue", code: "NU" },
    { id: 177, name: "Norfolk Island", code: "NF" },
    { id: 178, name: "Northern Mariana Islands", code: "MP" },
    { id: 179, name: "Norway", code: "NO" },
    { id: 180, name: "Oman", code: "OM" },
    { id: 181, name: "Pakistan", code: "PK" },
    { id: 182, name: "Palau", code: "PW" },
    { id: 183, name: "Palestinian Territory, Occupied", code: "PS" },
    { id: 184, name: "Panama", code: "PA" },
    { id: 185, name: "Papua New Guinea", code: "PG" },
    { id: 186, name: "Paraguay", code: "PY" },
    { id: 187, name: "Peru", code: "PE" },
    { id: 189, name: "Philippines", code: "PH" },
    { id: 190, name: "Pitcairn", code: "PN" },
    { id: 191, name: "Poland", code: "PL" },
    { id: 192, name: "Portugal", code: "PT" },
    { id: 193, name: "Puerto Rico", code: "PR" },
    { id: 194, name: "Qatar", code: "QA" },
    { id: 195, name: "Reunion", code: "RE" },
    { id: 196, name: "Romania", code: "RO" },
    { id: 197, name: "Russian Federation", code: "RU" },
    { id: 198, name: "RWANDA", code: "RW" },
    { id: 199, name: "Saint Helena", code: "SH" },
    { id: 200, name: "Saint Kitts and Nevis", code: "KN" },
    { id: 201, name: "Saint Lucia", code: "LC" },
    { id: 202, name: "Saint Pierre and Miquelon", code: "PM" },
    { id: 203, name: "Saint Vincent and the Grenadines", code: "VC" },
    { id: 204, name: "Samoa", code: "WS" },
    { id: 205, name: "San Marino", code: "SM" },
    { id: 206, name: "Sao Tome and Principe", code: "ST" },
    { id: 207, name: "Saudi Arabia", code: "SA" },
    { id: 208, name: "Senegal", code: "SN" },
    { id: 209, name: "Serbia and Montenegro", code: "CS" },
    { id: 210, name: "Seychelles", code: "SC" },
    { id: 220, name: "Sierra Leone", code: "SL" },
    { id: 221, name: "Singapore", code: "SG" },
    { id: 222, name: "Slovakia", code: "SK" },
    { id: 223, name: "Slovenia", code: "SI" },
    { id: 224, name: "Solomon Islands", code: "SB" },
    { id: 225, name: "Somalia", code: "SO" },
    { id: 226, name: "South Africa", code: "ZA" },
    { id: 227, name: "South Georgia and the South Sandwich Islands", code: "GS" },
    { id: 228, name: "Spain", code: "ES" },
    { id: 229, name: "Sri Lanka", code: "LK" },
    { id: 230, name: "Sudan", code: "SD" },
    { id: 231, name: "Suriname", code: "SR" },
    { id: 232, name: "Svalbard and Jan Mayen", code: "SJ" },
    { id: 233, name: "Swaziland", code: "SZ" },
    { id: 234, name: "Sweden", code: "SE" },
    { id: 235, name: "Switzerland", code: "CH" },
    { id: 236, name: "Syrian Arab Republic", code: "SY" },
    { id: 237, name: "Taiwan, Province of China", code: "TW" },
    { id: 238, name: "Tajikistan", code: "TJ" },
    { id: 239, name: "Tanzania, United Republic of", code: "TZ" },
    { id: 240, name: "Thailand", code: "TH" },
    { id: 241, name: "Timor-Leste", code: "TL" },
    { id: 242, name: "Togo", code: "TG" },
    { id: 243, name: "Tokelau", code: "TK" },
    { id: 244, name: "Tonga", code: "TO" },
    { id: 245, name: "Trinidad and Tobago", code: "TT" },
    { id: 246, name: "Tunisia", code: "TN" },
    { id: 247, name: "Turkey", code: "TR" },
    { id: 248, name: "Turkmenistan", code: "TM" },
    { id: 249, name: "Turks and Caicos Islands", code: "TC" },
    { id: 250, name: "Tuvalu", code: "TV" },
    { id: 251, name: "Uganda", code: "UG" },
    { id: 252, name: "Ukraine", code: "UA" },
    { id: 253, name: "United Arab Emirates", code: "AE" },
    { id: 254, name: "United Kingdom", code: "GB" },
    { id: 255, name: "United States", code: "US" },
    { id: 256, name: "United States Minor Outlying Islands", code: "UM" },
    { id: 257, name: "Uruguay", code: "UY" },
    { id: 258, name: "Uzbekistan", code: "UZ" },
    { id: 259, name: "Vanuatu", code: "VU" },
    { id: 260, name: "Venezuela", code: "VE" },
    { id: 261, name: "Viet Nam", code: "VN" },
    { id: 262, name: "Virgin Islands, British", code: "VG" },
    { id: 263, name: "Virgin Islands, U.S.", code: "VI" },
    { id: 264, name: "Wallis and Futuna", code: "WF" },
    { id: 265, name: "Western Sahara", code: "EH" },
    { id: 266, name: "Yemen", code: "YE" },
    { id: 267, name: "Zambia", code: "ZM" },
    { id: 268, name: "Zimbabwe", code: "ZW" },
];

export default countryCodes;
